import { useQuery } from 'react-query';
import { fetchDailyTrending } from '../services/api';

export const useDailyTrending = options => {
  return useQuery('dailyTrending', fetchDailyTrending, options);
};
